import React from "react";

export type Transformation = {
    scale: number;
    translate: { x: number; y: number };
};

export const defaultTransformation: Transformation = {
    scale: 1,
    translate: { x: 0, y: 0 }
};

export const TransformationContext = React.createContext<Transformation | undefined>(undefined);
